if (document.getElementById("faqs_widget")) {
    new Vue({
        data: () => ({
            faqsData: [],
            faqs: faqs,
            customer: "",
            category: "",
            topic: "",
            sortBy: "Most popular",
            sortByArr: ["Most popular", "Most relevant", "Newest", "Oldest", "A-Z"],
            pagination: {
                currentPage: 1
            },
            total: 100,
            maxSize: 3,
            enabledTopics: [],
        }),
        methods: {
            getQueryVariable(variable) {
                var query = window.location.search.substring(1);
                var vars = query.split("&");
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split("=");
                    if (pair[0] == variable) { return pair[1]; }
                }
                return "";
            },
            clearFilter() {
                this.topic = "";
                this.sortBy = this.sortByArr[0];
                this.category = "";
                this.customer = "";
                this.getData()
            },
            getData(paginationPosition) {
                document.querySelector('html').classList.add("loading");
                if (paginationPosition) {
                    paginationPosition = 1;
                } else {
                    paginationPosition = this.pagination.currentPage
                }
                const self = this;
                axios.post("/Umbraco/Api/XoserveApi/FaqFilter", {
                    "nodeId": self.faqs,
                    "sort": self.sortBy,
                    "topic": self.topic,
                    "category": self.category,
                    "customer": self.customer,
                    "pageNumber": paginationPosition,
                    "searchQuery": ""
                }, {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8'
                    }
                })
                    .then(function (response) {
                        self.faqsData = response.data.Results;
                        self.total = response.data.TotalNumberOfRecords;
                        self.maxSize = response.data.PageSize;
                        self.pagination.currentPage = response.data.PageNumber;
                        if (self.enabledTopics.length <= 1) {
                            self.enabledTopics = response.data.EnabledTopics.split(";");
                        }
                    })
                    .then(function () {
                        $('html, body').animate({
                            scrollTop: $('.main').offset().top
                        }, 300, function () {
                            let newurl = window.location.protocol + "//" + window.location.host + "/faqs?topic=" + self.topic + "&category=" + self.category + "&sortby=" + self.sortBy + "&search=&customer=" + self.customer;
                            window.history.pushState({ path: newurl }, document.title, newurl);
                            document.querySelector('html').classList.remove("loading");
                        })
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            sendFaq(e) {
                let counter = e.target.dataset.counter;
                // increase page views
                if (counter.length > 0) {
                    $.ajax({
                        type: "GET",
                        url: "/umbraco/api/xoserveapi/IncreaseFAQViews?nodeId=" + counter,
                        success: function (result) {
                            if (!result) {
                                //console.log('FAQ counter increase error');
                            } else {                                
                                e.target.dataset.counter = "";
                            }
                        }
                    });
                }
            }
        },
        created() {
            if (decodeURI(this.getQueryVariable("topic"))) {
                this.topic = decodeURI(this.getQueryVariable("topic"));
            }
            if (decodeURI(this.getQueryVariable("category"))) {
                this.category = decodeURI(this.getQueryVariable("category"));
            }
            if (decodeURI(this.getQueryVariable("customer"))) {
                this.customer = decodeURI(this.getQueryVariable("customer"));
            }
            if (decodeURI(this.getQueryVariable("sortby"))) {
                this.sortBy = decodeURI(this.getQueryVariable("sortby"));

            }
            this.getData()
        },
        computed: {
            disabledClearBtn() {
                if (this.topic == "" && this.sortBy == "Most popular" && this.category == "" && this.customer == "") {
                    return true
                } else {
                    return false
                }
            }
        }
    }).$mount('#faqs_widget');
}